import { render, staticRenderFns } from "./ListaPacotes.vue?vue&type=template&id=5c729cdf"
import script from "./ListaPacotes.vue?vue&type=script&lang=js"
export * from "./ListaPacotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports